import Image from 'next/image'

import { Text } from '@wartek-id/text'

import CategoryBlock from './CategoryBlock'

import type { FC } from 'react'

const HIGHLIGHT_BANNER = {
  url: '',
  about: '',
  link: '',
}

const Header: FC = () => {
  return (
    <>
      <div className="bg-[#0036A3] flex flex-col">
        <div className="flex items-center px-4 py-4 pt-6 space-x-3 justify-items-center">
          <div>
            <Image
              layout="fixed"
              src="/icon/ide-praktik.svg"
              alt=""
              width={60}
              height={60}
            />
          </div>
          <div className="flex flex-col items-start space-y-1">
            <Text color="inverse" variant="heading-md">
              Ide Praktik
            </Text>
            <Text color="inverse" variant="body-sm">
              Artikel dan video terpilih untuk membantu Ibu Bapak Guru praktik
              pembelajaran terpusat pada murid.
            </Text>
          </div>
        </div>
      </div>

      <CategoryBlock />

      {String(HIGHLIGHT_BANNER.url).length > 0 && (
        <div className="flex flex-col gap-3 p-4">
          <a href={HIGHLIGHT_BANNER.link} target="_blank" rel="noreferrer">
            <img alt={HIGHLIGHT_BANNER.about} src={HIGHLIGHT_BANNER.url} />
          </a>
        </div>
      )}
    </>
  )
}
export default Header
